<template>
  <div
    class="gateway"
    :key="key"
    :style="nodeStyle"
  >
    <img :src="gateway" />
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
  import { GATE_WAY } from './const'
  import getNodeMixin from '../mixins/getNode'

  export default {
    name: 'Gateway',
    mixins: [getNodeMixin],
    computed: {
      type() {
        return this.data?.type || 'bpmn:ParallelGateway'
      },
      gateway() {
        return GATE_WAY[this.type]
      },
    },
  }
</script>

<style lang="scss" scope>
  .gateway {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba($color: #000000, $alpha: 0.4);

    img {
      width: 30px;
      height: 30px;
    }

    .label {
      position: absolute;
      top: calc(100% + 8px);
      left: 50%;
      font-size: 12px;
      text-align: center;
      white-space: nowrap;
      opacity: 0.5;
      transform: translateX(-50%);
    }
  }
</style>
